import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackContactSupportClicked = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);
    trackProductAnalytics('Contact Support Clicked');
  }, [productEvents]);

  return trackCallback;
};

export default useTrackContactSupportClicked;
